import React from 'react';
import { Avatar, Box, Skeleton } from '@mui/material';
import Grid from '@mui/material/Grid2';
import Paper from '@mui/material/Paper';
import Header from 'components/Layouts/components/Header';

export default function UserProfileSkeleton() {
  return (
    <>
      <Header />
      <Box
        component='main'
        sx={{
          flexGrow: 1,
          padding: { xs: 2, lg: 3 },
          paddingTop: { xs: '120px', lg: '150px' },
          width: { xs: '100%', lg: '50%' }
        }}
        marginX='auto'
      >
        {/* Page Title Skeleton */}
        <Skeleton variant='text' width={150} height={40} sx={{ height: { xs: 32, lg: 40 } }} />

        {/* Form Paper Skeleton */}
        <Paper
          elevation={1}
          sx={{
            border: '1px solid #F3F3F3',
            padding: { xs: 2, lg: '24px' },
            borderRadius: '4px',
            marginTop: { xs: 2, lg: '24px' }
          }}
        >
          {/* Avatar Section Skeleton */}
          <Skeleton variant='text' width={60} height={24} sx={{ mb: 1 }} />
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              gap: { xs: 2, sm: '16px' },
              alignItems: { xs: 'flex-start', sm: 'center' },
              marginTop: { xs: 2, sm: '8px' }
            }}
          >
            <Avatar sx={{ width: 64, height: 64, flexShrink: 0 }} />
            <Skeleton variant='rectangular' height={40} sx={{ borderRadius: 1, width: { xs: '100%', sm: 120 } }} />
            <Skeleton variant='text' height={20} sx={{ width: { xs: '100%', sm: 120 } }} />
          </Box>

          {/* Form Fields Grid Skeleton */}
          <Grid container spacing={{ xs: 2, lg: '26px' }} marginTop={{ xs: 2, lg: '24px' }}>
            {/* Name Field */}
            <Grid size={{ xs: 12, lg: 6 }}>
              <Skeleton variant='text' width={60} height={20} sx={{ mb: 1 }} />
              <Skeleton variant='rectangular' width='100%' height={56} sx={{ borderRadius: 1 }} />
            </Grid>

            {/* Email Field */}
            <Grid size={{ xs: 12, lg: 6 }}>
              <Skeleton variant='text' width={100} height={20} sx={{ mb: 1 }} />
              <Skeleton variant='rectangular' width='100%' height={56} sx={{ borderRadius: 1 }} />
            </Grid>

            {/* Phone Field */}
            <Grid size={{ xs: 12, lg: 6 }}>
              <Skeleton variant='text' width={100} height={20} sx={{ mb: 1 }} />
              <Skeleton variant='rectangular' width='100%' height={56} sx={{ borderRadius: 1 }} />
            </Grid>
          </Grid>

          {/* Save Button Skeleton */}
          <Box
            sx={{
              marginTop: { xs: 2, lg: '24px' },
              display: 'flex',
              justifyContent: { xs: 'stretch', lg: 'flex-end' }
            }}
          >
            <Skeleton variant='rectangular' height={40} sx={{ borderRadius: 1, width: { xs: '100%', lg: 140 } }} />
          </Box>
        </Paper>
      </Box>
    </>
  );
}
